@if (model) {
  <div class="tile">
    <h5 class="mb-4 font-medium">
      {{ model.headline }}
    </h5>
    <div class="font-light">{{ model.text }}</div>
  </div>
}
